import {zoomInit} from './image-zoom';

jQuery(document).ready(function ($) {
    let scale = 1;
    let X = 0, Y = 0, pressTimer;
    let moveAction = {
        mouseDown: false,
        tempX: 0,
        tempY: 0
    };
    /*
     * Общие настройки ajax-запросов, отправка на сервер csrf-токена
     */
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    /*
     * Добавление товара в корзину с помощью ajax-запроса без перезагрузки
     */
    $('form.ajax-form-catalog').submit(function (e) {
        // отменяем отправку формы стандартным способом
        e.preventDefault();
        // получаем данные этой формы добавления в корзину
        var $form = $(this);
        var data = new FormData($form[0]);
        $.ajax({
            url: $form.attr('action'),
            data: data,
            processData: false,
            contentType: false,
            type: 'POST',
            dataType: 'HTML',
            beforeSend: function () {
                var spinner = ' <span class="spinner-border spinner-border-sm"></span>';
                // $form.find('button').append(spinner);
            },
            success: function (html) {
                $form.slideUp(250);
                $('#top-basket').html(html);
                $form.after('<a style="display:none; font-size: 10px;" class="btn btn-success text-white btn-md h-100 link-zakaz p-2 col-12" href="/zakaz/"><i class="fa fa-thumbs-up" aria-hidden="true"></i> Перейти к расчёту</a>');
                setTimeout(() => {
                    $('.link-zakaz').slideDown(250);
                }, 250);
            }
        });
    });

    // Форма быстрого заказа прямо со странцы запчастей
    $('form#fastOrder').submit((e) => {
        // отменяем отправку формы стандартным способом
        e.preventDefault();
        e.returnValue = false;
        // получаем данные этой формы добавления в корзину
        var $form = $('form.ajax-form-catalog');
        var data = new FormData($form[0]);
        $.ajax({
            url: $form.attr('action'),
            data: data,
            processData: false,
            contentType: false,
            type: 'POST',
            dataType: 'HTML',
            beforeSend: function () {
                var spinner = ' <span class="spinner-border spinner-border-sm"></span>';
                $('form#fastOrder').find('button').append(spinner);
            },
            success: function () {
                $('form#fastOrder').off('submit');
                $('form#fastOrder').submit();
                // $form.slideUp(250);
                // $('#top-basket').html(html);
                // $form.after('<a style="display:none" class="btn btn-success btn-sm link-zakaz p-2 col-12" href="/zakaz/"><i class="fa fa-thumbs-up" aria-hidden="true"></i> Перейти к расчёту</a>');
                // setTimeout(() => { $('.link-zakaz').slideDown(250); }, 250);
            }
        });
    });

    // Чек или анчек всех товаров
    $('.check-all-products').click((e) => {
        for (const selector of $('.ajax-form-checkbox')) {
            selector.checked = e.currentTarget.checked;
        }
    });

    // Добавление в расчет выбранных артикулов
    $('button.add-all-products').click((e) => {
        console.log('clicked');
        const data = $('.table-content-item')
        const button = $('button.add-all-products');
        let requestData = {
            multiply: true,
            _token: document.querySelector('#__token').value,
            request: []
        };
        for (let i = 0; i < data.length; i++) {
            const checkbox = data[i].querySelector('input.ajax-form-checkbox');
            if (!checkbox.checked) continue;
            const product = data[i].querySelector('input.ajax-form-product');
            const quantity = data[i].querySelector('input.ajax-form-quantity');
            requestData.request.push({
                product: product.value,
                quantity: quantity.value
            });
        }
        if (requestData.request.length === 0) return null;
        $.ajax({
            url: $('form.ajax-form-catalog').attr('action'),
            data: JSON.stringify(requestData),
            processData: false,
            contentType: 'application/json',
            type: 'POST',
            // dataType: 'json',
            beforeSend: function () {
                var spinner = ' <span class="spinner-border spinner-border-sm"></span>';
                button.append(spinner);
            },
            success: function (html) {
                console.log(html);
                button.slideUp(250);
                // $('#top-basket').html(html);
                button.after('<a style="display:none" class="btn btn-success btn-sm p-2 col-4 mt-3 link-zakaz" href="/zakaz/"><i class="fa fa-thumbs-up" aria-hidden="true"></i> Перейти к расчёту</a>');
                setTimeout(() => {
                    $('.link-zakaz').slideDown(250);
                }, 250);
            }
        });
    });

    function defaultResize() {
        if ($('div#picture-wrap').length) {
            scale = Math.min($('div#picture-area').width() / $('div#picture-wrap').width(), $('div#picture-area').height() / $('div#picture-wrap').height());
            $('div#picture-wrap').css('transform', `scale(${scale})`);
            X -= $('div#picture-wrap').position().left;
            Y -= $('div#picture-wrap').position().top;
            $('div#picture-wrap').css({top: Y, left: X});
            if (!$('div#picture-area').data('readonly')) {
                $('div#picture-area').height($('div#picture-wrap').height() * scale);
            }
        }
    }

    defaultResize();

    zoomInit();

    $('#exampleModalCenter').on('shown.bs.modal', (e) => {
        zoomInit();
    });

    $('form.ajax-form').reloadable();

    // При клике на леблы изображения выделяем их
    $('div.picture-label').on('click', (e) => {
        const link = 'itemId_' + e.target.dataset.label;
        $(`input#${link}`).prop('checked', !$(`input#${link}`)[0].checked);
        e.target.classList.toggle('bg-warning')
    });
    // При клике на чекбоксы в таблице выделяем артикул
    $('input.ajax-form-checkbox').on('click', (e) => {
        const link = e.target.id;
        $(`div.${link}`).toggleClass('bg-warning');
        e.target.setAttribute('checked', !e.target.checked);
    });
});

(function ($) {
    $.fn.reloadable = function () {
        $(this).submit(function (e) {
            // отменяем отправку формы стандартным способом
            e.preventDefault();
            // получаем данные этой формы добавления в корзину
            var $form = $(this);
            var data = new FormData($form[0]);
            $.ajax({
                url: $form.attr('action'),
                data: data,
                processData: false,
                contentType: false,
                type: 'POST',
                dataType: 'HTML',
                beforeSend: function () {
                    var spinner = ' <span class="spinner-border spinner-border-sm"></span>';
                    $form.find('button').append(spinner);
                },
                success: function (html) {
                    $form.find('.spinner-border').remove();
                    $('.zakaz-container').html(html);
                    $('.ajax-form').reloadable();
                }
            });
        });
    }
})(jQuery);

